import { createBrowserRouter } from 'react-router-dom';
import DefaultLayout from '@/layouts/DefaultLayout';
import AppLayout from '@/layouts/AppLayout';
import Landing from '@/routes/Landing';
import Dashboard from '@/routes/app/Dashboard';
import Setup from '@/routes/app/Setup';
import Connections from '@/routes/app/Connections';
import Settings from '@/routes/app/Settings';
import TransactionsList from '@/routes/app/transactions/List';
import TransactionReview from '@/routes/app/transactions/Review';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultLayout />,
    children: [{ index: true, element: <Landing /> }],
  },
  {
    path: '/app',
    element: <AppLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'setup', element: <Setup /> },
      { path: 'connections', element: <Connections /> },
      { path: 'settings', element: <Settings /> },
      { path: 'transactions', element: <TransactionsList /> },
      { path: 'transactions/:id', element: <TransactionReview /> },
    ],
  },
]);
